import { formatIsoDay, formatNumber, formatTRY } from "@/lib/format";

const TIP = "Bugünkü Kur ile Maliyet = (Kesin Maliyet TL ÷ ithalattaki kur) × bugünkü TCMB döviz satış kuru. Kaynak TRY ise Kesin Maliyet ile aynıdır.";

const Box = ({ title, value, children, testid, tip }) => (
  <div className="rounded border-2 border-blue-600 bg-blue-50 p-3" data-testid={testid} title={tip}>
    <div className="text-[11px] uppercase tracking-wider text-blue-700 font-semibold">{title}</div>
    <div className="text-xl font-bold font-mono" data-testid={`${testid}-value`}>{value}</div>
    <div className="text-[12px] text-slate-600">{children}</div>
  </div>
);

export const CostBoxes = ({ c }) => {
  if (!c) return null;
  const imp = c.kind === "ithalat";
  return (
    <>
      <Box title={imp ? "Kesin Maliyet (ithal tarihinde)" : "Kesin Maliyet (yurt içi alış)"} value={formatTRY(c.kesin_try)} testid="cost-box-kesin">
        {c.doc_no} · {formatIsoDay(c.date)}{imp && c.currency !== "TRY" && <> · kur {formatNumber(c.fx_rate, 4)} {c.currency}</>}
      </Box>
      <Box title="Bugünkü Kur ile Maliyet" value={c.today_try != null ? formatTRY(c.today_try) : "—"} testid="cost-box-today" tip={`${TIP}\n${c.formula || ""}`}>
        {c.today_rate ? <>{formatNumber(c.source_unit, 4)} {c.currency} × {formatNumber(c.today_rate, 4)} · {c.rate_source || "TCMB"} {formatIsoDay(c.rate_date)}{c.rate_stale && <span className="text-amber-700"> (son bilinen kur)</span>}</>
          : c.currency === "TRY" ? "Kaynak TRY: kesin maliyet ile aynı" : (c.rate_warning || "Kur bulunamadı")}
      </Box>
    </>
  );
};
